import * as yup from "yup";

export const signUpSchema = yup.object({
  company_name: yup
    .string()
    .label("Company Name")
    .required("Company name is required"),
  user_name: yup
    .string()
    .label("Name")
    .required("Name is required"),
  domain: yup
    .string()
    .label("Domain")
    .transform((value) => (value ? value.toLowerCase() : value))
    .test('no-special-chars', 'Domain must not contain special characters', (value) => {
      if (!value) return true;
      return /^[a-zA-Z0-9-]+$/.test(value);
    })
    .required("Domain is required"),
  email: yup
    .string()
    .label("Email")
    .email("Invalid email address")
    .required("Email is required"),
});
